<template>
  <div
    class="app-main-content"
  >
    <div class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          :show-more-scheme="false"
          :show-simple="false"
          :expand-adv="true"
          config-module="2200"
          :show-adv="true"
          @click-more="value=>{isAdvancedQuery=value}"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button no="button1" type="primary" @click="createEstimate()">{{
              $t('CargoMsg.Cargo_CreateEstimate')
            }}
            </el-button>
            <el-button no="button3" type="danger" @click="deleteEstimate()">{{
              $t('CargoMsg.Cargo_OrderDelete')
            }}
            </el-button>
            <el-button no="button4" type="primary" @click="sendSharedCenter()">{{
              $t('CargoMsg.Cargo_SendSharingCenter')
            }}
            </el-button>
            <el-button no="button5" type="primary" @click="querySendResult()">{{
              $t('CargoMsg.Cargo_GetSendResult')
            }}
            </el-button>
            <el-button no="button6" type="primary" @click="aLittleSend()">{{
              $t('CargoMsg.Cargo_ALittleSend')
            }}
            </el-button>
          </div>
          <template v-slot:searchAreaHeader>
            <div class="app-main-inner-row  extension-conditions-form" style="padding-bottom: 5px;margin-top: -7px">
              <div class="filters">
                <el-form :inline="true" label-width="60px" label-position="left">
                  <div class="el-form-item-wrapper dense-radio-group">
                    <el-form-item :label="$t('CargoMsg.Cargo_PaymentReceiveMethod')" class="dense-radio-group">
                      <el-radio-group v-model="filter.applicationStatus" @change="applicationStatusLabelChange">
                        <el-radio :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
                        <el-radio :label="0">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </div>
          </template>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="220002011"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <div style="display: flex;justify-content: flex-end;flex-wrap: wrap;margin-top: 5px">
            <span v-show="dataShow && totalAmountToCurrency.selectionCountLabel" v-text="totalAmountToCurrency.selectionCountLabel" />
            <charge-currency-total-group
              v-if="reCalc"
              :amount-to-currency="localCurrency"
              data-field="amount"
              :data-provider="totalAmountToCurrency.dataProvider"
              ar-field="ar"
              currency-field="currency"
              type="revenueAbs"
              :amount-to-currency-label="$t('SeaExport.Convert')"
              :arap-group="false"
            />
          </div>
          <cargo-pagination
            config-module="220002012"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="query"
          />
        </div>
      </div>
    </div>

    <select-date-dialog
      v-if="showSelectDateDialog"
      ref="selectDateDialog"
      :application-status="filter.applicationStatus"
      :info="{title:$t('CargoMsg.Cargo_SelectiveFinanceMonth'),label:$t('CargoMsg.Cargo_FinancialMonth')}"
      :disabled-after-today="false"
      :visible.sync="showSelectDateDialog"
    />

    <push-log-dialog
      v-if="pushLogDialog.visible"
      :visible.sync="pushLogDialog.visible"
      :uuid="pushLogDialog.uuid"
    />
  </div>
</template>

<script>
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage } from '@/utils/commonUtil'
import {
  advancedQueryFunc,
  deleteFunc,
  pushPreliminaryFunc,
  queryOrderLogFunc
} from '@/api/act/preliminaryEstimate'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import joinChargeDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/joinChargeDialog'
import selectDateDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/selectDateDialog'
import pushLogDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/pushLogDialog'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { localCurrencyByOffice } from '@/class/cargo/model/utils/RateUtil'
import { getGridSelected } from '@/utils/agGrid'
import { Once } from '@/utils/commonUtil'

export default {
  name: 'EstimateListQuery',
  components: { pushLogDialog, searchItem, ChargeCurrencyTotalGroup, joinChargeDialog, selectDateDialog },
  data() {
    return {
      loading: false,
      isAdvancedQuery: false, // 记录上一次操作是否为高级查询
      documentManage: new DocumentManage(),
      SystemConstants,
      reCalc: true,
      dataShow: true,
      localCurrency: 'RMB',
      once: new Once(this),
      pushLogDialog: {
        visible: false,
        uuid: ''
      },
      filter: {
        conditions: {},
        applicationStatus: 1,
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {},
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        context: { componentParent: this },
        onSelectionChanged: this.filterChange
      },
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_ENo'),
          field: 'tentativeEstimateNo',
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'currency',
          width: 180
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvoiceTitle'),
          field: 'invoiceTitle',
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_Amount'),
          field: 'amount',
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          field: 'createdBy',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreatedDate'),
          field: 'dateCreated',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BillDate2'),
          field: 'accountingDate',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_MonthlyFinancial'),
          field: 'financialMonth',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lob',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ResultSuccess'),
          field: 'state',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.SHARED_TYPES)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PushLog'),
          field: 'state',
          width: 130,
          cellRenderer: (params) => {
            if (!params.data) {
              return ''
            }
            if (params.data.state !== 1) {
              const uuid = params.data.uuid
              const methodOnFileViewPath = this.documentManage.getPath('onView')
              return `<a onclick="${methodOnFileViewPath}('${uuid}')" style="color:blue">
                    ${this.$t('CargoMsg.Cargo_View')}
                    </a>`
            } else {
              return ''
            }
          }
        }
      ],
      doneList: [3, 4, 5],
      noneList: [-1, 1, 2],
      rowData: [],
      showSelectDateDialog: false,
      gridApi: null,
      // 分页组件内统计数据
      totalAmountToCurrency: {
        dataProvider: [],
        selectionCountLabel: ''
      }
    }
  },
  created() {
    this.toAdvancedQuery([])
    this.init()
    this.setLocalCurrency()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onView', function(value) {
      context.onView(value)
    })
  },
  methods: {
    async init() {
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      // 查询完成后更新右下角统计数据
      this.refreshSelectedCount()
      this.loading.close()
    },
    query(data) {
      this.toAdvancedQuery()
    },
    // 高级查询
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      this.filterJson.accountReceivable = (this.filter.applicationStatus === 1)
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading4Cxt(this)
      advancedQueryFunc(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 创建暂估单
    createEstimate() {
      this.showSelectDateDialog = true
    },
    cancelResult() {
      this.showSelectDateDialog = false
    },

    // 删除
    deleteEstimate() {
      const items = this.gridApi.getSelectedRows()
      if (!items || items.length <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      for (const data of items) {
        if (this.doneList.includes(data.state)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectNoDelete'))
          return
        }
      }
      const uuids = Array.from(items, p => p.uuid)
      deleteFunc({ 'uuidList': uuids }).then(res => {
        this.$message.success(this.$t('Menu.SuccessfullyDeleted'))
        this.query()
      })
    },
    // 发送共享中心
    sendSharedCenter(otherCustomer) {
      const selections = this.gridApi.getSelectedRows()
      if (!selections || selections.length <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      const keys = []
      for (const data of selections) {
        if (this.doneList.includes(data.state)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectNoPushData'))
          return
        }
        keys.push(data.uuid)
      }
      const filterJson = {}
      filterJson.uuidList = keys
      filterJson.type = (this.filter.applicationStatus === 1) ? 'arPreliminary' : 'apPreliminary'
      filterJson.branchId = this.$store.getters.currentOfficeId
      filterJson.accountReceivable = (this.filter.applicationStatus === 1)
      filterJson.autoQuery = true
      filterJson.otherCustomer = otherCustomer || ''
      const loading = getLoading4Cxt(this)
      pushPreliminaryFunc(filterJson).then(res => {
        if (res.data) {
          const data = res.data
          if (data.errorCode) {
            this.$message.warning(ColumnUtils.showTypeLabelFunc(data.errorCode, SystemConstants.ERROR_MAPPING_TYPE))
          } else if (data.syncTip) {
            this.$message.success(ColumnUtils.showTypeLabelFunc(data.syncTip, SystemConstants.ASYNC_MAPPING_TYPE))
          } else {
            this.$message.success(this.$t('CargoMsg.Cargo_SendingResult', [data.successCount, data.failCount]))
            this.query()
          }
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 获取发送结果
    querySendResult() {
      const selections = this.gridApi.getSelectedRows()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      const keys = []
      for (const data of selections) {
        if (this.noneList.includes(data.state)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectInvoiceAR2'))
          return
        }
        keys.push(data.tentativeEstimateNo)
      }
      const filterJson = {}
      filterJson.uuidList = keys
      filterJson.type = (this.filter.applicationStatus === 1) ? 'arPreliminary' : 'apPreliminary'
      filterJson.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading4Cxt(this)
      queryOrderLogFunc(filterJson).then(res => {
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.Cargo_doTip'))
          this.query()
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 作为零星客户推送
    aLittleSend() {
      this.sendSharedCenter('SporadicCustomer')
    },

    applicationStatusLabelChange() {
      this.query()
    },
    onView(value) {
      this.pushLogDialog.visible = true
      this.pushLogDialog.uuid = value
    },
    // 列表checkBox选中变更事件
    filterChange() {
      const selections = getGridSelected(this.gridOptions)
      this.dataShow = true
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCount, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
            }
          } else {
            this.dataShow = false
            this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
          }
        })
      }
    },
    setLocalCurrency() {
      this.localCurrency = localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    refreshSelectedCount(arg, selections) {
      if (arg === 0) {
        const selectStr = this.$t('Message.Choose')
        this.totalAmountToCurrency.selectionCountLabel = selectStr + ' ' + selections.length + '：'
        this.totalAmountToCurrency.dataProvider = selections
      } else if (arg === 1) {
        this.totalAmountToCurrency.dataProvider = selections
        this.totalAmountToCurrency.selectionCountLabel = ''
      } else {
        this.totalAmountToCurrency.dataProvider = this.rowData
        this.totalAmountToCurrency.selectionCountLabel = ''
      }
    }
  }
}
</script>
